<template>
  <!--
      作者：kmdshop
      时间：2020-06-01
      描述：插件中心-入驻码-添加
    -->
    <el-dialog
    title="添加入驻码"
    :visible.sync="dialogVisible"
    @close="dialogFormVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="50%"
  >

  <div class="product-add pb50">

    <el-form size="small" :model="form" ref="form" :rules="rules" label-width="100px">
      <div class="common-form">添加入驻码</div>

      <el-form-item label="添加数量" prop="num"><el-input type="number" min="1" max="500" v-model="form.num" placeholder="请输入添加数量" class="max-w460"></el-input></el-form-item>
      
      <!--提交-->
      <div class="common-button-wrapper">
        <el-button size="small" type="info" @click="cancelFunc">取消</el-button>
        <el-button size="small" type="primary" @click="onSubmit" :loading="loading">提交</el-button>
      </div>
    </el-form>
  </div>
</el-dialog>
  
</template>

<script>
import Merchant_onboardingApi from '@/api/merchant_onboarding.js';

export default {
  components: {

  },
  data() {
    return {
      /*form表单数据*/
      form: {
        num: 1
      },
      loading: false,
      /*验证规则*/
      rules: {
        num: [{ required: true, message: '请输入添加数量', trigger: 'blur' }],
      },
      dialogVisible:false
    };
  },
  created() {
    console.log(11111)
    this.dialogVisible = this.open_add;
  },
  props: ["open_add"],
  methods: {

     /*关闭弹窗*/
     dialogFormVisible(result) {
      this.$emit("close", { openDialog: false,"type":"" });
    },
    cancelFunc(){//取消
      this.dialogFormVisible("error")
    },

    onSubmit() {
      let self = this;
      let form = self.form;
      self.$refs.form.validate(valid => {
        if (valid) {
          self.loading = true;
          Merchant_onboardingApi.add(form, true)
            .then(data => {
              self.loading = false;
              self.$message({
                message: data.msg,
                type: 'success'
              });
              self.dialogFormVisible("error")
            })
            .catch(error => {
              self.loading = false;
            });
        }
      });
    },

  }
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/plus/merchant_onboarding/index/part/add.vue